const React = require("react")
const Info = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14V14C4.686 14 2 11.314 2 8V8C2 4.686 4.686 2 8 2V2C11.314 2 14 4.686 14 8V8C14 11.314 11.314 14 8 14Z"
        stroke="#0087DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9987 11.3333V8H7.33203"
        stroke="#0087DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.83267 5.33268C7.74067 5.33268 7.666 5.40735 7.66667 5.49935C7.66667 5.59135 7.74134 5.66602 7.83334 5.66602C7.92534 5.66602 8 5.59135 8 5.49935C8 5.40735 7.92534 5.33268 7.83267 5.33268"
        stroke="#0087DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

module.exports = {
  Info
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/prompt/icons/info.js